import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Logo from '@/components/images/logo.png';
import api from '@/auth/api';
import { alertSuccess } from '@/components/Alert';
import '@/components/css/login.css'

const SetPassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required('New password is required')
      .min(8, 'Password must be at least 8 characters')
      .matches(/(?=.*[0-9])/, 'Must include at least one number')
      .matches(/(?=.*[!@#$%^&*])/, 'Must include one special character (!@#$%^&*)'),
    confirmPassword: Yup.string()
      .required('Confirm your password')
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
  });

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    try {
      await api.post(`/account/panel/setPassword/${uid}/${token}`, {
        password : values.newPassword,
        password2:values.confirmPassword
      });
      alertSuccess('Password set successfully. Please login.');
      setTimeout(()=>{
      navigate('/login');

      },3000)
    } catch (error) {
      setErrors({ general: error.response?.data?.errors || 'Something went wrong' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100">
      <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg md:flex md:h-[80vh] min-h-[400px] overflow-hidden">
        {/* Left Section */}
        <div className="md:w-1/2 bg-blue-500 loginLeft text-white flex flex-col items-center p-2">
          <img className="max-w-28 rounded mt-12" src={Logo} alt="Logo" />
          <h1 className="text-4xl font-bold mb-4">Set Your Password</h1>
          <p className="text-lg text-center p-4">
            Create a new password to access your 5th Poll Dashboard account securely.
          </p>
        </div>

        {/* Right Section */}
        <div className="md:w-1/2 p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Set Password</h2>
          <Formik
            initialValues={{ newPassword: '', confirmPassword: '' }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors }) => (
              <Form>
                {errors.general && (
                  <div className="text-red-500 text-sm mb-4" aria-live="assertive">
                    {errors.general}
                  </div>
                )}

                <div className="mb-4">
                  <label htmlFor="newPassword" className="block text-gray-700 font-medium mb-2">
                    New Password
                  </label>
                  <Field
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    placeholder="Enter new password"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <ErrorMessage
                    name="newPassword"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <div className="mb-6">
                  <label htmlFor="confirmPassword" className="block text-gray-700 font-medium mb-2">
                    Confirm Password
                  </label>
                  <Field
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder="Re-enter new password"
                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-red-500 text-sm mt-1"
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-blue-500 text-white font-medium py-2 px-4 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 setPasswordBtn"
                >
                  {isSubmitting ? 'Setting password...' : 'Set Password'}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
